import { z } from "zod";

export const addressSchema = z.object({
    id: z.number().optional(),
    Address_Type: z.number().optional(),
    street: z.string().optional(),
    street_number: z.string().optional(),
    Postcode: z.number().nullable(),
});

export const addressTypeSchema = z.object({
    id: z.number(),
    addressCategory: z.string(),
})

export type IAddress = z.infer<typeof addressSchema>;
export type IAddressType = z.infer<typeof addressTypeSchema>;